/**
 * Download reflection entries as JSON.
 * @param {unknown[]} entries
 * @param {string} [filename]
 */
export function downloadReflectionsJson(entries, filename) {
  const list = Array.isArray(entries) ? entries : [];
  const stamp = new Date().toISOString().slice(0, 10);
  const name = filename || `ahavibes-reflections-${stamp}.json`;
  const blob = new Blob([JSON.stringify(list, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  URL.revokeObjectURL(url);
}

/**
 * Map server insight rows to export-friendly objects.
 */
export function mapInsightsForExport(insights) {
  return (insights || []).map((item) => ({
    id: item.id,
    createdAt: item.created_at || item.createdAt,
    entry: item.entry_text || item.reflection || "",
    insight: item.insight_json || {
      event_reflection: item.eventReflection,
      interpretation_reflection: item.interpretationReflection,
      evidence_reflection: item.evidenceReflection,
      response_statement: item.responseStatement,
      behavior_pattern: item.behaviorPattern,
      behavior_action: item.behaviorAction,
      sentiment: item.sentiment
    }
  }));
}

/**
 * Map local device reflections to export-friendly objects.
 */
export function mapLocalReflectionsForExport(entries) {
  return (entries || []).map((item) => ({
    id: item.id,
    createdAt: item.createdAt,
    event: item.event,
    interpretation: item.interpretation,
    evidence: item.evidence,
    response: item.response
  }));
}
